<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/S3c9g0/tc-custom/9781398441453.jpg?1705540911248" alt="This image is the cover for the book Sometime in August"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sometime in August
      </h1>
      <p class="bookDescription body article font2">
        <p>Sometimes you need a lifetime to tell a story. Sometimes you only need four days. Heather Thompson is a 20-year-old with an arguably great life: the makings of a dream career, supportive friends and family, and a relationship lifted right out of a romance novel. But that doesn’t mean she isn’t struggling. Sometime in August is an honest, no-holds-barred account of mental ill-health in a young adult, which follows four life-changing days in Heather’s life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amy Taylor Cook
      </h2>
      
      <p class="authorDescription body article">Amy Taylor Cook has been an aspiring author since she could hold a pen. Her debut novel Sometime in August is based partly on her own experiences with mental health, and it aims to discuss the topic in a blunt and relatable manner. Amy grew up in East Kilbride, Greater Glasgow, where she currently lives with her fiancé along with pet snails and a huge collection of books.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e9e03d00